import React, { Component, ReactNode } from 'react'
import PageHeading from './PageHeading'

interface HeadingRowProps {
  heading: string
  doc?: string
  children: ReactNode
}

export default class HeadingRow extends Component<HeadingRowProps> {
  render () {
    return (
      <div className="flex flex-col lg:flex-row lg:justify-between items-start mb-5 gap-5">
        <PageHeading text={this.props.heading} doc={this.props.doc} />
        <div className="flex gap-5">
          {this.props.children}
        </div>
      </div>
    )
  }
}
